module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "m-l-50 m-t-30"
  }, [_c('common-config', {
    attrs: {
      "id": _vm.id,
      "form": _vm.form,
      "inputList": _vm.inputList,
      "isLimit": _vm.isLimit,
      "isDepended": _vm.isDepended,
      "isLogic": _vm.isLogic
    }
  }, [_c('template', {
    slot: "self-config"
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showInputConfig
    }
  }, [_vm._v("页面布局")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showCudConfig
    }
  }, [_vm._v("连贯操作")])]), _vm._v(" "), (_vm.typeAdd) ? _c('el-form-item', {
    attrs: {
      "label": "操作类型"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.show_type),
      expression: "form.show_type"
    }],
    domProps: {
      "value": (_vm.form.show_type)
    },
    on: {
      "input": function($event) {
        _vm.form.show_type = $event
      }
    }
  }, _vm._l((_vm.typeOptions), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))]) : _vm._e(), _vm._v(" "), (_vm.typeMultiAdd) ? _c('el-form-item', {
    attrs: {
      "label": "选择外键"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.child_field_id),
      expression: "form.child_field_id"
    }],
    domProps: {
      "value": (_vm.form.child_field_id)
    },
    on: {
      "input": function($event) {
        _vm.form.child_field_id = $event
      }
    }
  }, _vm._l((_vm.keyFields), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.name + '(' + item.title + ')',
        "value": item.field_id
      }
    })
  }))]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "打开方式"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.open_type),
      expression: "form.open_type"
    }],
    domProps: {
      "value": (_vm.form.open_type)
    },
    on: {
      "input": function($event) {
        _vm.form.open_type = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 10
    }
  }, [_vm._v("页面")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 20
    }
  }, [_vm._v("弹窗")])])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "自动传GET参数"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.is_query),
      expression: "form.is_query"
    }],
    domProps: {
      "value": (_vm.form.is_query)
    },
    on: {
      "input": function($event) {
        _vm.form.is_query = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("开启")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("关闭")])])])])], true), _vm._v(" "), _c('input-config', {
    ref: "inputConfig",
    attrs: {
      "inputType": _vm.inputType,
      "inputTitle": _vm.inputTitle,
      "curGroupIds": _vm.curGroupIds,
      "conditionLists": _vm.form.group
    },
    on: {
      "confirmCurField": _vm.confirmCurField,
      "confirmCondition": _vm.confirmCondition,
      "setConditionListShow": _vm.setConditionListShow,
      "setInputListShow": _vm.setInputListShow,
      "resetTempInputList": _vm.resetTempInputList,
      "setCurGroupIds": _vm.setCurGroupIds,
      "showDeleteConfirmDialog": _vm.showDeleteConfirmDialog
    }
  }), _vm._v(" "), _c('input-list', {
    ref: "inputList",
    attrs: {
      "inputList": _vm.tempInputList
    },
    on: {
      "setNewInputList": _vm.setNewInputList,
      "openDepentConfig": _vm.openDepentConfig,
      "setKeyDepent": _vm.setKeyDepent,
      "confirmDepentConfig": _vm.confirmDepentConfig
    }
  }), _vm._v(" "), _c('condition-list', {
    ref: "conditionList",
    attrs: {
      "inputList": _vm.tempInputList
    },
    on: {
      "setNewConditionList": _vm.setNewConditionList
    }
  }), _vm._v(" "), _c('depent-config', {
    ref: "depentConfig",
    attrs: {
      "keyDepent": _vm.keyDepent,
      "showName": _vm.showName
    }
  }), _vm._v(" "), _c('cud-config', {
    ref: "cudConfig",
    attrs: {
      "modelId": _vm.modelId,
      "cudConfig": _vm.form.cud_config
    },
    on: {
      "setCudConfig": _vm.setCudConfig
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-75f3011a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Content/abstract/dealConfig/formConfig.vue
// module id = 1925
// module chunks = 2